import React from "react"
import { useSelector } from "react-redux"
import MainPaper from "src/features/Components/MainPaper"
import { makeStyles } from "@material-ui/core/styles"
import { get } from "lodash"
import Typography from "@material-ui/core/Typography"
import { withComma, fixed2 } from "src/features/Utils/price"

const useStyles = makeStyles((theme) => ({
  root: { height: "100%" },
  title: { marginBottom: theme.spacing(4) },
}))

function Index() {
  const classes = useStyles()
  const detail = useSelector((state) => state.medicine.detail)

  return (
    <MainPaper elevation={0} className={classes.root}>
      <Typography
        variant="caption"
        component="p"
        color="textSecondary"
        className={classes.title}
      >
        Base Price
      </Typography>
      <Typography variant="h5">
        ฿{withComma(fixed2(get(detail, "price", 0)))}
      </Typography>
      <Typography variant="caption" color="textSecondary">
        including vat
      </Typography>
    </MainPaper>
  )
}

export default Index
